export default "/_next/static/images/img2-57c6bd4b37219b55027f779360ab59b2.png";